export enum UrlModalParam {
    Open = "open",
    For = "for"
}

export enum UrlModalType {
    Waitlist = "waitlist"
}

// Re-export from waitlist slice
export { WaitlistFeature } from "@/store/slices/waitlistSlice";
